export default __webpack_public_path__ + "static/media/938.d572821e.gif";